module.exports = __webpack_public_path__ + "img/pencil_fill.bfb09422.svg";